/**
 * Implementation of ProtectedLayout HOC which allow any component to be accessed
 * only to authenticated users
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactComponentElement, ReactElement, ReactNode, ReactPropTypes, PropsWithoutRef } from "react";
import { Navigate } from "react-router-dom";
import { getUserToken } from "../../api/getUserToken";

export default function ProtectedLayout(Component: React.FunctionComponent) {
  return function(props: PropsWithoutRef<{}>) {
    const token = getUserToken()

    if(!token)
      return <Navigate to="/auth/login" replace />

    return <Component {...props} />
  } 
}